import axiosClient from '@app/services/axios';
import {
    INIT_RESULT_MSG,
    nhadan_METHOD
} from '@app/const/AppSetting';
import {getSaveResult} from '@app/utils/helpers';
import axiosClientExcel from "@app/services/axiosExcel";

const  MY_METHOD = nhadan_METHOD;

export const myService = {
    // eslint-disable-next-line no-use-before-define
    
    getAll,
    getById,
    Create,
    Update,
    Delete,
    excel,excelPath,getRefById,Create_Tailieu,Delete_Tailieu,GetLocation,Active,Inactive
};

function excelPath(params) {
    return getSaveResult(axiosClient.post(`${MY_METHOD}excelPath`, params));
}

async function Create_Tailieu(id,file,param) {
    let formData = new FormData();

    formData.append('fileUpload', file);
    if(param )
    {
        Object.keys(param).forEach(key => {
            formData.append(key, param[key]);
        });
    }
    //console.log(param);
    const res = await axiosClient
        .post(`${MY_METHOD}tailieu/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((responde) => {
            return responde.data;
        })
        .catch((error) => {
            return {...INIT_RESULT_MSG, msg: `Exception:${error.message}`};
        });
    return res;
}

function Delete_Tailieu(id) {
    return getSaveResult(axiosClient.delete(`${MY_METHOD}tailieu/${id}`));
}

function getRefById(CurrentPage, PageSize, paramFilter) {
    const v = axiosClient
        .post(
            `${MY_METHOD}ref/${CurrentPage}/${PageSize}`,
            paramFilter
        )
        .then((responde) => {
            return responde.data.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}

function getAll(CurrentPage, PageSize, paramFilter) {
    const v = axiosClient
        .post(
            `${MY_METHOD}search/${CurrentPage}/${PageSize}`,
            paramFilter
        )
        .then((responde) => {
            return responde.data;
        })
        .catch((error) => {
            return null;
        });
    return v;
}


function getById(id) {
    return axiosClient.get(`${MY_METHOD}${id}`);
}

function Create(params) {
    return getSaveResult(axiosClient.post(`${MY_METHOD}`, params));
}
function Delete(id) {
    return getSaveResult(axiosClient.delete(`${MY_METHOD}${id}`));

}
function Active(id) {
    return getSaveResult(axiosClient.post(`${MY_METHOD}active/${id}`));
}

function Inactive(id) {
    return getSaveResult(axiosClient.post(`${MY_METHOD}inactive/${id}`));
}

function Update(id, params) {
    return getSaveResult(axiosClient.put(`${MY_METHOD}${id}`, params));
}

function GetLocation(id) {
    return getSaveResult(axiosClient.post(`${MY_METHOD}location/${id}`));
}

function excel(CurrentPage, PageSize, paramFilter) {
    return axiosClientExcel.post(`${MY_METHOD}excel/${CurrentPage}/${PageSize}`,
            paramFilter);
    
}
